import { render } from "./COMMENTS.vue?vue&type=template&id=643e4f23&ts=true"
import script from "./COMMENTS.vue?vue&type=script&lang=ts"
export * from "./COMMENTS.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__